import * as actions from "../action.constants";

const initialState = {
  alertsListData: {},
  downtimeCreateData: [],
  metricCreateData: [],
  logs: [],
};

const alertsListObject = (state, action) => ({
  ...state,
  alertsListData: action.payload || {},
});

const DowntimeCreateList = (state, action) => ({
  ...state,
  downtimeCreateData: action.payload,
});

const MetricCreateList = (state, action) => ({
  ...state,
  metricCreateData: action.payload,
});

const metricFieldList = (state, action) => ({
  ...state,
  metricFieldList: action.payload,
});

const storeCreateAlertData = (state, action) => ({
  ...state,
  createAlertModalData: action.payload,
});

const storeSensorsForAlert = (state, action) => ({
  ...state,
  sensorsList: action.payload,
});

const storeAlarmHistoryLogs = (state, action) => ({
  ...state,
  logs: action.payload,
});

const handlers = {
  [actions.SAVE_ALERTS_LIST_DATA]: alertsListObject,
  [actions.STORE_DOWNTIME_CREATE_DATA]: DowntimeCreateList,
  [actions.STORE_METRIC_CREATE_DATA]: MetricCreateList,
  [actions.STORE_METRIC_FIELD]: metricFieldList,
  [actions.UPDATE_CREATE_ALERT_DATA]: storeCreateAlertData,
  [actions.STORE_SENSORS_FOR_ALERT]: storeSensorsForAlert,
  [actions.STORE_ALARM_HISTORY_LOGS]: storeAlarmHistoryLogs,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
